import Loader from '@/shared/ui/Loader';
import React from 'react';

const Fallback = () => {
	return (
		<div className='w-screen h-screen bg-[#080024] flex justify-center items-center'>
			<Loader />
		</div>
	);
};

export default Fallback;
